import { AuthenticationContext, adalGetToken } from "react-adal";

const apiConfig = {
  apiUrl: process.env.REACT_APP_API_HOST,
};
const siteConfig = {
  siteName: "Maestro portal",
  siteIcon: "ion-flash",
  footerText: "MAERSK Service",
};

const themeConfig = {
  topbar: "themedefault",
  sidebar: "themedefault",
  layout: "themedefault",
  theme: "themedefault",
};
const language = "english";

const adalConfig = {
  tenant: process.env.REACT_APP_TENANT,
  clientId: process.env.REACT_APP_CLIENT_ID,
  endpoints: {
    api: process.env.REACT_APP_API,
  },
  redirectUri: window.location.protocol + "//" + window.location.host,
  postLogoutRedirectUri: window.location.origin,
  cacheLocation: "sessionStorage",
};
const authContext = new AuthenticationContext(adalConfig);
const authGetTokenForResource = (resourceGuiId, callback) => {
  return new Promise((resolve, reject) => {
    adalGetToken(authContext, resourceGuiId, callback)
      .then(resolve)
      .catch((error) => {
        // Workaround for Safari's ITP 2.0
        // Ref: https://github.com/AzureAD/azure-activedirectory-library-for-js/wiki/Known-issue-on-Safari
        if (error.message === "Token renewal operation failed due to timeout") {
          authContext
            .acquireTokenRedirect(resourceGuiId)
            .then(resolve)
            .catch(reject);
        } else {
          reject(error);
        }
      });
  });
};

var raToolClientId =
  process.env.REACT_APP_RUN_ENV === "development"
    ? "7d1df8f1-0bd1-4562-a948-4ca4aaf7bbb3"
    : "95cb4153-97f4-4c9a-a4c2-a3850bf92c07";
const raToolAdalConfig = {
  tenant: process.env.REACT_APP_TENANT,
  clientId: raToolClientId,
  endpoints: {
    api: `https://maersk.onmicrosoft.com/${raToolClientId}`,
  },
  redirectUri: window.location.protocol + "//" + window.location.host,
  postLogoutRedirectUri: window.location.origin,
  cacheLocation: "sessionStorage",
};
const raToolAuthContext = new AuthenticationContext(raToolAdalConfig);
const raToolAuthGetTokenForResource = (resourceGuiId, callback) => {
  return new Promise((resolve, reject) => {
    adalGetToken(raToolAuthContext, resourceGuiId, callback)
      .then(resolve)
      .catch((error) => {
        // Workaround for Safari's ITP 2.0
        // Ref: https://github.com/AzureAD/azure-activedirectory-library-for-js/wiki/Known-issue-on-Safari
        if (error.message === "Token renewal operation failed due to timeout") {
          raToolAuthContext
            .acquireTokenRedirect(resourceGuiId)
            .then(resolve)
            .catch(reject);
        } else {
          reject(error);
        }
      });
  });
};

// Need to remove this changes once dev environment is ready for RA tool or geo fancing.
/**      ################# Start ################## **/
let geoFencingClientId =
  process.env.REACT_APP_RUN_ENV === "development"
    ? "95cb4153-97f4-4c9a-a4c2-a3850bf92c07"
    : "7d1df8f1-0bd1-4562-a948-4ca4aaf7bbb3";

const geoFancingAdalConfig = {
  tenant: process.env.REACT_APP_TENANT,
  clientId: geoFencingClientId,
  endpoints: {
    api: `https://maersk.onmicrosoft.com/${geoFencingClientId}`,
  },
  redirectUri: window.location.protocol + "//" + window.location.host,
  postLogoutRedirectUri: window.location.origin,
  cacheLocation: "sessionStorage",
};
const geoFancingAuthContext = new AuthenticationContext(geoFancingAdalConfig);
const geoFancingAuthGetTokenForResource = (resourceGuiId, callback) => {
  return new Promise((resolve, reject) => {
    adalGetToken(geoFancingAuthContext, resourceGuiId, callback)
      .then(resolve)
      .catch((error) => {
        // Workaround for Safari's ITP 2.0
        // Ref: https://github.com/AzureAD/azure-activedirectory-library-for-js/wiki/Known-issue-on-Safari
        if (error.message === "Token renewal operation failed due to timeout") {
          geoFancingAuthContext
            .acquireTokenRedirect(resourceGuiId)
            .then(resolve)
            .catch(reject);
        } else {
          reject(error);
        }
      });
  });
};

/**      ###################  End  ################ **/

// Need to remove this changes once dev environment is ready for penny.
/**      ################# Start ################## **/
var maestroApplicationsClientId =
  process.env.REACT_APP_RUN_ENV === "development"
    ? "95cb4153-97f4-4c9a-a4c2-a3850bf92c07"
    : "7d1df8f1-0bd1-4562-a948-4ca4aaf7bbb3";
const maestroApplicationsAdalConfig = {
  tenant: process.env.REACT_APP_TENANT,
  clientId: maestroApplicationsClientId,
  endpoints: {
    api: `https://maersk.onmicrosoft.com/${maestroApplicationsClientId}`,
  },
  redirectUri: window.location.protocol + "//" + window.location.host,
  postLogoutRedirectUri: window.location.origin,
  cacheLocation: "sessionStorage",
};
const maestroAppsAuthContext = new AuthenticationContext(
  maestroApplicationsAdalConfig
);
const maestroAppsAuthGetTokenForResource = (resourceGuiId, callback) => {
  return new Promise((resolve, reject) => {
    adalGetToken(maestroAppsAuthContext, resourceGuiId, callback)
      .then(resolve)
      .catch((error) => {
        // Workaround for Safari's ITP 2.0
        // Ref: https://github.com/AzureAD/azure-activedirectory-library-for-js/wiki/Known-issue-on-Safari
        if (error.message === "Token renewal operation failed due to timeout") {
          maestroAppsAuthContext
            .acquireTokenRedirect(resourceGuiId)
            .then(resolve)
            .catch(reject);
        } else {
          reject(error);
        }
      });
  });
};

/**      ###################  End  ################ **/

/** ContainerCloudAADService configurations */
/**      ################# Start ################## **/
let containerCloudClientId =
  process.env.REACT_APP_RUN_ENV === "development"
    ? "aca121cd-bd0e-4814-b288-cbcc25b1cfda"
    : "865eea46-3328-47f4-824e-6c044f26ce18";

const containerCloudAdalConfig = {
  tenant: process.env.REACT_APP_TENANT,
  clientId: containerCloudClientId,
  endpoints: {
    api: `https://maersk.onmicrosoft.com/${containerCloudClientId}`,
  },
  redirectUri: window.location.protocol + "//" + window.location.host,
  postLogoutRedirectUri: window.location.origin,
  cacheLocation: "sessionStorage",
};
const containerCloudAuthContext = new AuthenticationContext(containerCloudAdalConfig);
const containerCloudAuthGetTokenForResource = (resourceGuiId, callback) => {
  return new Promise((resolve, reject) => {
    adalGetToken(containerCloudAuthContext, resourceGuiId, callback)
      .then(resolve)
      .catch((error) => {
        // Workaround for Safari's ITP 2.0
        // Ref: https://github.com/AzureAD/azure-activedirectory-library-for-js/wiki/Known-issue-on-Safari
        if (error.message === "Token renewal operation failed due to timeout") {
          containerCloudAuthContext
            .acquireTokenRedirect(resourceGuiId)
            .then(resolve)
            .catch(reject);
        } else {
          reject(error);
        }
      });
  });
};

/**      ###################  End  ################ **/

const getToken = () => {
  return authContext.getCachedToken(authContext.config.clientId);
};

const userName = () => {
  if (authContext.getCachedUser()) {
    return authContext.getCachedUser().profile.name;
  } else {
    return "";
  }
};

const userEmailId = () => {
  if (authContext.getCachedUser()) {
    return authContext.getCachedUser().userName;
  } else {
    return "";
  }
};

export {
  siteConfig,
  themeConfig,
  language,
  apiConfig,
  authContext,
  authGetTokenForResource,
  getToken,
  userName,
  userEmailId,
  raToolAuthGetTokenForResource,
  geoFancingAuthGetTokenForResource,
  containerCloudAuthGetTokenForResource,
  maestroAppsAuthGetTokenForResource,
};
